import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'start-game',
  },
  {
    path: 'start-game',
    loadComponent: () => import('./global/pages/start-game-page/start-game-page.component').then((m) => m.StartGamePageComponent),
  },
  {
    path: 'tv',
    loadComponent: () => import('./global/pages/tv-page/tv-page.component').then((m) => m.TvPageComponent),
  },
  {
    path: 'leaderboards',
    loadComponent: () => import('./global/pages/leaderboards-page/leaderboards-page.component').then((m) => m.LeaderboardsPageComponent),
  },
  {
    path: 'game-details/:gameId',
    loadComponent: () => import('./global/pages/game-details-page/game-details-page.component').then((m) => m.GameDetailsPageComponent),
  },
];
